import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropertyPanelsProps } from './PropertyPanels';
import './MapPropertyPanel.css';

const MapPropertyPanel: React.FC<PropertyPanelsProps> = ({ property }) => {
  const { t } = useTranslation();

  // Get property-specific content
  const getContentForProperty = () => {
    switch (property.toLowerCase()) {
      case 'patagonia':
      default:
        return {
          title: t('properties/patagonia:mapPanel.title'),
          description: t('properties/patagonia:mapPanel.description'),
          mapUrl: "/assets/images/map/patagonia-global-map.svg"
        };
      case 'atacama':
        return {
          title: t('properties/atacama:mapPanel.title'),
          description: t('properties/atacama:mapPanel.description'),
          mapUrl: "/assets/images/map/atacama-global-map.svg"
        };
      case 'iguazu':
        return {
          title: t('properties/iguazu:intro.subtitle'),
          description: t('properties/iguazu:intro.description'),
          mapUrl: "/assets/images/map/iguazu-global-map.svg"
        };
      case 'mendoza':
        return {
          title: t('properties/mendoza:mapPanel.title'),
          description: t('properties/mendoza:mapPanel.description'),
          mapUrl: "/assets/images/map/mendoza-global-map.svg"
        };
      case 'santa-catarina':
      case 'santacatarina':
        return {
          title: t('properties/santa-catarina:mapPanel.title'),
          description: t('properties/santa-catarina:mapPanel.description'),
          mapUrl: "/assets/images/map/santa-catarina-global-map.svg"
        };
    }
  };

  const content = getContentForProperty();
  return (
    <div className="map-panel">
      <div className="map-panel__content">
        <div className={`map-panel__map map-panel__map--${property}`}>
          <img src={content.mapUrl} alt="Map of the property" className="map-panel__map-image"/>
        </div>
        <div className="map-panel__text">
          <h2 className="map-panel__heading">{content.title}</h2>
          <p className='map-panel__description'>{content.description}</p>
        </div>
      </div>
      <div className="map-panel__media">
        <img className="map-panel__image" src={"/assets/figma/" + property + "-interior-gallery.png"} alt="Interior gallery images" />
      </div>
    </div>
  );
};

export default MapPropertyPanel;